import ManagedLookup from '../components/ManagedLookup';
import useLookupPage from '../hooks/useLookupPage';
import fields from './fields';
import columns from './columns';

const WeatherZones = ({ definition }) => {
    const page = useLookupPage('weather-zones', columns);
    return <ManagedLookup definition={definition} columns={columns} fields={fields} page={page} />;
};
export default WeatherZones;
